import { Injectable } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from './GlobalService';

@Injectable()
export class DrawerService {
  private drawers = [];
  private offcanvasses = new Map<string, NgbOffcanvasRef>

  constructor(
    private offcanvasService: NgbOffcanvas,
    private _globalService: GlobalService,
  ) { }


  setDrawer(position: Drawerposition, drawer, id: DrawerIdentifier, panelClass: string = '', showBackdrop = true, scroll = false) {
    //console.log(position, drawer)
    if (this.drawers.filter((drawer) => drawer.id === id).length > 0)
      console.warn('There is already a drawer set with the id of: ' + id);
    this.drawers.push({ position: position, el: drawer, id: id, panelClass: panelClass, showBackdrop: showBackdrop, scroll:scroll });
  }

  // if a component gets destroyed, remove this local reference as well
  //because it will not work as expected when reinitializing the same component again
  clearDrawer(id: DrawerIdentifier) {
    this.drawers = this.drawers.filter((drawer) => drawer.id !== id);
  }

  findDrawer(id: DrawerIdentifier): any {
    const drawer = this.drawers.find((drawer) => drawer.id === id);
    if(!drawer && this._globalService.isInBrowser) 
      console.warn('There is no drawer set with the id of: ' + id)
    return drawer;
  }

  dismissAll(): void {
    this.offcanvasService.dismiss();
  }
  dismiss(id: DrawerIdentifier) {
    if(!this.offcanvasses.has(id)) return;

    this.offcanvasses.get(id).dismiss();
  }

  update(id: DrawerIdentifier, drawer) {
    const d = this.findDrawer(id)
    d.drawer = drawer;
  }

  open(id:DrawerIdentifier):NgbOffcanvasRef{
    const drawer = this.findDrawer(id);
    if(!drawer) return;

    if(this.offcanvasses.has(id)){
      console.warn('There is already a drawer open with the id of: ' + id);
      return;
    }

    const offcanvas = this.offcanvasService.open(
      drawer.el,
      {
        backdrop: drawer.showBackdrop,
        position: drawer.position,
        ariaLabelledBy: drawer.id ? drawer.id : 'offcanvas-left-menu',
        panelClass: drawer.panelClass,
        scroll: drawer.scroll
      })
    
    this.offcanvasses.set(id, offcanvas);

    const sub = offcanvas.dismissed.subscribe(()=>{
      this.offcanvasses.delete(id);
      sub.unsubscribe();
    })

    return offcanvas;

  }

  close(id:DrawerIdentifier){
    const drawer = this.findDrawer(id);
    if(!drawer) return;

    if(!this.offcanvasses.has(id)){
      if(this._globalService.isInBrowser)
        console.warn('There is no drawer open with the id of: ' + id);
      return;
    }

    this.offcanvasses.get(id).dismiss();
    this.offcanvasses.delete(id);
  }

  toggle(id:DrawerIdentifier): NgbOffcanvasRef {
    if (!this.offcanvasses.has(id)) {
      return this.open(id)
    } else {
      this.close(id)
      return null;
    }
  }

  isOpen(id:DrawerIdentifier):boolean{
    return this.offcanvasses.has(id)
  }
}

export enum Drawerposition {
  start = 'start',
  end = 'end',
  bottom = 'bottom',
  top = 'top'
}

export enum DrawerIdentifier{
  leftMenuDrawer = 'left-drawer',
  weekrecipeRecipedetails = 'recipedetails-drawer-weekrecipes',
  orderflowDrawer = 'orderflow-drawer',
  lifestyleBottomDrawer = 'lifestyle-bottom-drawer',
  allrecipesBottomDrawer = 'allrecipes-bottom-drawer',
  recipeBottomDrawer = 'recipe-bottom-drawer',
  webshopRightDrawer = 'webshop-drawer',
  telemarketingRightDrawer = 'telemarketing-drawer',
  userOrderdrawer = 'orderoverview-drawer',
  userBottomdrawer = 'bottom-drawer',
  userTaxonomydrawer = 'taxonomy-drawer'

}
